import React from 'react';
import TeamCard from '../components/TeamCard';
import PageHeader from './Shared/PageHeader';

const Team = () => {
    const TeamData = [
        {
            id: '1',
            img: 'images/team/1.jpg',
            name: 'Walter Barren',
            tag: 'Head Chef',
        },
        {
            id: '2',
            img: 'images/team/2.jpg',
            name: 'Anthony Spoomer',
            tag: 'Continental Chef',
        },
        {
            id: '3',
            img: 'images/team/3.jpg',
            name: 'Jamie Jared',
            tag: 'Head Baker',
        },
        {
            id: '4',
            img: 'images/team/4.jpg',
            name: 'Kevin Johenson',
            tag: 'Apprentice',
        },
        {
            id: '5',
            img: 'images/team/5.jpg',
            name: 'James Charls',
            tag: 'Assistant Chef',
        },
        {
            id: '6',
            img: 'images/team/6.jpg',
            name: 'Parker Balinger',
            tag: 'Assistant Chef',
        },
        {
            id: '7',
            img: 'images/team/7.jpg',
            name: 'James Charls',
            tag: 'Assistant Chef',
        },
        {
            id: '8',
            img: 'images/team/8.jpg',
            name: 'Erica Svetlov',
            tag: 'Assistant Chef',
        },
    ];
    return (
        <div>
            <PageHeader title="Our Team"></PageHeader>

            <div className="main-wrapper">
                <div className="team">
                    <div className="container">
                        <div className="row">
                            {TeamData.map(data => <TeamCard
                                key={data.id}
                                data={data}
                            />)}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Team;